export const COMPRESS_CONFIG = {
    maxWidth: 1920,          // Max lebar setelah compress
    maxHeight: 1920,         // Max tinggi setelah compress
    quality: 0.8,            // Kualitas JPEG (0.1 - 1.0)
    outputType: "image/jpeg" // Format output (JPEG lebih kecil)
  };